import { useEffect, useState } from "react";
import { MinimalRow, PossibleColumnProps } from "../types";
import { useLocalStorage } from "./useLocalStorage";
import { useLocation } from "react-router";

export default function useVisibleColumns<TRow extends MinimalRow>(
  allColumns: PossibleColumnProps<TRow>[],
) {
  const { pathname } = useLocation();
  const storageKey = `${pathname.replace(/\W/g, "")}_visible_columns`;

  const [storedFields, setStoredFields] = useLocalStorage<string[]>(
    `${storageKey}_visible_columns`,
    [],
  );

  const defaultFields = allColumns
    .filter((column) => column.isDefaultVisible)
    .map((column) => column.field);

  const initialFields = storedFields.length > 0 ? storedFields : defaultFields;

  const [visibleColumns, setVisibleColumns] = useState<
    PossibleColumnProps<TRow>[]
  >(allColumns.filter((column) => initialFields.includes(column.field)));

  useEffect(() => {
    const currentFields = visibleColumns.map((column) => column.field);
    setStoredFields(currentFields);
  }, [visibleColumns, setStoredFields]);

  return [visibleColumns, setVisibleColumns] as const;
}
